import { Icon } from "@abb/abb-common-ux-react/components/Icon";
import React from "react";
import { Translation } from "react-i18next";
import { RouteComponentProps } from "react-router";
import measurementActions from "../../flux/actions/MeasurementActions";
import { ICalculatedDetails } from "../../models/measurement/CalculatedDetails";
import {
  IInstrumentDetails,
  InstrumentDetails,
} from "../../models/measurement/InstrumentDetails";
import { IKeyedInDetails } from "../../models/measurement/KeyedInDetails";
import IMeasuredDetails from "../../models/measurement/MeasuredDetails";
import SampleViewData, {
  defaultSampleData,
  ISampleViewData,
} from "../../models/sample/SampleViewData";
import { Status } from "../../models/sample/Status";

type ILandingprops = {
  changeGridView: () => void;
  showInstrumentProperty?: (data: any) => void;
  showKeyedInProperty: () => void;
  activeItem: any;
  measurementDetails: IMeasuredDetails;
  keyedInDetailsData?: any;
  calculatedDetailsData?: ICalculatedDetails[];
};

interface ILandingState {}

export default class MeasurementLanding extends React.Component<
  ILandingprops,
  ILandingState
> {
  private _measurementDetails: any[] = [];
  private _sampleInstrumentDetails: any[] = [];

  render() {
    return (
      <Translation>
        {(t) => (
          <React.Fragment>
            <div className="col-12">
              <div className="divider"></div>
            </div>

            {/* LANDING GRID PAGE = FOR NOT MEASURED STATE */}
            <div className="row measureItemContainer">
              {/* Measured */}
              {this.props.activeItem?.status?.name === Status.NOTMEASURED &&
                this.props.activeItem?.measured.length > 0 &&
                (this.props.activeItem.measured || []).map((item: any) => {
                  return (
                    <div className="col-xl-3 col-lg-4 col-md-6 col-xs-6 no-padding">
                      <div
                        className={
                          item.checkInstrumentInUse?.status === "In Use"
                            ? "measureItems disabled cursor-default d-flex"
                            : "measureItems cursor-default d-flex"
                        }
                        onClick={this.props.showInstrumentProperty}
                      >
                        <button
                          title="Start"
                          className="icon-button circle btn-40 m-0 float-left cursor-default"
                        >
                          <Icon
                            name="abb/play"
                            className={
                              this.props.activeItem.status.name === "NotMeasured"
                                ? "iconDisabled"
                                : ""
                            }
                            sizeClass="small"
                          />
                        </button>
                        <div className="details">
                          <p className="title no-margin">{item.instrument && item.instrument.name ? item.instrument.name :''}</p>
                          {item.checkInstrumentInUse?.status === "In Use" ? (
                            <p className="statusGray no-margin">
                              {t(item?.checkInstrumentInUse?.status)}{" "}
                              {item?.checkInstrumentInUse?.sampleName}
                            </p>
                          ) : (
                            <p className="statusGreen">
                              {item.instrumentStatus?.name === Status.NOTMEASURED
                                ? t(Status.AVAILABLE)
                                : t(item.instrumentStatus?.name)}
                            </p>
                          )}
                          <p>0 ({item?.totalCounts??0})</p>
                        </div>
                        <progress value="0" max="100">
                          {" "}
                          0{" "}
                        </progress>
                      </div>
                    </div>
                  );
                })}

              {/* KeyedIn */}
              {this.props.activeItem?.status?.name == Status.NOTMEASURED &&
                this.props.activeItem?.keyedIns.length > 0 &&
                (this.props.activeItem.keyedIns || []).map((item: any) => {
                  return (
                    <div className="col-xl-3 col-lg-4 col-md-6 col-xs-6 no-padding">
                      <div
                        className="measureItems cursor-default"
                        onClick={this.props.showKeyedInProperty}
                      >
                        <div className="details">
                          <p className="title">{item.property && item.property.name ? item.property.name : ''}</p>
                          <p className="statusGray">
                            {t(item.keyedInPropertyStatus && item.keyedInPropertyStatus.name ? item.keyedInPropertyStatus.name : '')}
                          </p>
                          <p>0 ({item?.totalCounts??0})</p>
                        </div>
                        <progress value="0" max="100">
                          {" "}
                          0{" "}
                        </progress>
                      </div>
                    </div>
                  );
                })}

              {/* Calculated */}
              {this.props.activeItem?.status?.name === Status.NOTMEASURED &&
                this.props.activeItem?.calculated?.length > 0 &&
                (this.props.activeItem.calculated || []).map((item: any) => {
                  return (
                    <div className="col-xl-3 col-lg-4 col-md-6 col-xs-6 no-padding">
                      <div
                        className="measureItems cursor-default"
                        onClick={this.props.showKeyedInProperty}
                      >
                        <div className="details">
                          <p className="title">{item?.name??''}</p>
                          <p className="statusGray">{t(Status.PENDING)}</p>
                        </div>
                        <progress value="0" max="100"></progress>
                      </div>
                    </div>
                  );
                })}
            </div>

            {/* LANDING GRID PAGE = FOR MEASURING STATUS */}
            <div className="row measureItemContainer">
              {/* MEASURING STATUS */}
              {this.props.measurementDetails?.instrumentDetails?.length > 0 &&
                (this.props.measurementDetails.instrumentDetails || []).map(
                  (item: any) => {
                    return (
                      <div className="col-xl-3 col-lg-4 col-md-6 col-xs-6 no-padding">
                        <div
                          className={
                            item.checkInstrumentInUse?.status === "In Use"
                              ? this.props.measurementDetails.name !==
                                item.checkInstrumentInUse?.sampleName
                                ? "measureItems disabled cursor-default"
                                : "measureItems cursor-default"
                              : "measureItems cursor-default"
                          }
                          onClick={this.props.showInstrumentProperty}
                        >
                          <button
                            title=""
                            className="icon-button circle btn-40 m-0 float-left cursor-default"
                          >
                            {this.props.measurementDetails.name ===
                            item.checkInstrumentInUse?.sampleName ? (
                              <Icon name="abb/stop" sizeClass="small" />
                            ) : (
                              <Icon
                                name="abb/play"
                                className={
                                  item.checkInstrumentInUse?.status ===
                                    "In Use" &&
                                  this.props.measurementDetails.name !==
                                    item.checkInstrumentInUse?.sampleName
                                    ? "iconDisabled"
                                    : ""
                                }
                                sizeClass="small"
                              />
                            )}
                          </button>
                          <div className="details">
                            <p className="title">{item?.name??''}</p>
                            {item.checkInstrumentInUse?.status === "In Use" ? (
                              <p className="statusGray">
                                {t(item.checkInstrumentInUse?.status??'')}{" "}
                                {item.checkInstrumentInUse?.sampleName??''}
                              </p>
                            ) : (
                              <p className="statusGreen">
                                {item.status.name === Status.NOTMEASURED
                                  ? t(Status.AVAILABLE)
                                  : t(item.status?.name??'')}
                              </p>
                            )}

                            <p>
                              {item.count.completedCounts} (
                              {item.count.totalCounts})
                            </p>
                          </div>
                          <progress
                            value={item.count.completedCounts}
                            max={item.count.totalCounts}
                          >
                            {item.completionPercentage}{" "}
                          </progress>
                        </div>
                      </div>
                    );
                  }
                )}

              {/* KEYEDIN STATUS */}
              {this.props.keyedInDetailsData?.keyedInDetails?.length > 0 &&
                (this.props.keyedInDetailsData.keyedInDetails || []).map(
                  (item: any) => {
                    return (
                      <div className="col-xl-3 col-lg-4 col-md-6 col-xs-6 no-padding">
                        <div
                          className="measureItems cursor-default"
                          onClick={this.props.showKeyedInProperty}
                        >
                          <div className="details">
                            <p className="title">{item?.name??''}</p>
                            <p className="statusGray">{t(item.status?.name??'')}</p>
                            <p>
                              {item.counts[0].completedCounts} (
                              {item.counts[0].totalCounts})
                            </p>
                          </div>
                          <progress
                            value={item.counts[0].completedCounts}
                            max={item.counts[0].totalCounts}
                          ></progress>
                        </div>
                      </div>
                    );
                  }
                )}

              {/* CALCULATED STATUS */}
              {this.props.calculatedDetailsData?.length > 0 &&
                (this.props.calculatedDetailsData || []).map((item: any) => {
                  return (
                    <div className="col-xl-3 col-lg-4 col-md-6 col-xs-6 no-padding">
                      <div
                        className="measureItems cursor-default"
                        onClick={this.props.showKeyedInProperty}
                      >
                        <div className="details">
                          <p className="title">{item?.name??''}</p>
                          <p className="statusGray">{t(Status.PENDING)}</p>
                        </div>
                        <progress value={0} max={100}></progress>
                      </div>
                    </div>
                  );
                })}
            </div>
          </React.Fragment>
        )}
      </Translation>
    );
  }
}
